import { listaEstadosActivo, listaPrivilegios } from "../../../../app/constants/constants-selectores";
import { CONST_ROL_MASTER } from "../../../../app/constants/constanst-valores";
import type { UsuarioFormCamposProps } from "./UsuarioFormCampos.types";

// Datos laborales y de acceso: correo laboral, área, KPC, huella, estado y privilegio.
export const UsuarioFormDatosLaborales = ({
    register,
    errors,
    rol,
}: UsuarioFormCamposProps) => {
    return (
        <>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Correo Lab</label>
                    <input
                        {...register("email_lab", {
                            // INCIDENCIA Validaciones (2026-08-17): correo laboral opcional; mismo criterio.
                            validate: (v: any) => {
                                const val = (v ?? "").toString().trim();
                                if (!val) return true;
                                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || "Correo laboral no válido (ejemplo: usuario@dominio.com)";
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
                {errors.email_lab && <p role="alert" className="error px-2 mb-0">{errors.email_lab.message}</p>}
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Fecha de ingreso</label>
                    <input
                        {...register("fingreso")}
                        type="date"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Area</label>
                    <input
                        {...register("area")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Anexo</label>
                    <input
                        {...register("anexo")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">IP</label>
                    <input
                        {...register("ip")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Usuario kpc</label>
                    <input
                        {...register("usuariokpc")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Clave kpc</label>
                    <input
                        {...register("clavekpc")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Id huella</label>
                    <input
                        {...register("useridhuella")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Estado</label>
                    <select {...register("estado")} className="form-select form-select-sm" >
                        {
                            listaEstadosActivo?.length > 0 && listaEstadosActivo.map(e => (
                                <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                            ))
                        }
                    </select>
                </div>
            </div>
            {/* <div className="col-12 col-lg-6">
            <div className="d-flex align-items-center">
                <label className="col-4 text-start px-2">Permiso</label>
                <select {...register("permiso")} className="form-select form-select-sm" >
                    {
                        listaPermisos?.length > 0 && listaPermisos.map(p => (
                            <option key={p?.id} value={p?.id}>{p?.tipo}</option>
                        ))
                    }
                </select>
            </div>
        </div> */}
            {
                rol === CONST_ROL_MASTER && (
                    <div className="col-12 col-lg-6">
                        <div className="d-flex align-items-center">

                            <label className="col-4 text-start px-2">Privilegio</label>
                            <select {...register("privilegio")} className="form-select form-select-sm" >
                                {
                                    listaPrivilegios?.length > 0 && listaPrivilegios.map(p => (
                                        <option key={p?.id} value={p?.id}>{p?.tipo}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                )
            }
        </>
    )
}
